import { render } from "./LbrxKeyboardPopup.vue?vue&type=template&id=2362448b&scoped=true"
import script from "./LbrxKeyboardPopup.vue?vue&type=script&lang=js"
export * from "./LbrxKeyboardPopup.vue?vue&type=script&lang=js"

import "./LbrxKeyboardPopup.vue?vue&type=style&index=0&id=2362448b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2362448b"]])

export default __exports__